import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

const accordion = {
  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll<HTMLElement>('.accordion').forEach((target: HTMLElement) => {
      this.handleAccordion(target)
    })
  },

  handleAccordion(target): void {
    const el = {
      items: target.querySelectorAll('.accordion__item'),
      itemHeads: target.querySelectorAll('.accordion__head'),
    }

    const method = {
      init(): void {
        el.items.forEach((item, index) => {
          el.itemHeads[index].addEventListener('click', () => {
            method.toggleItem(item)
          })
        })
      },

      runAnimation(action, item): void {
        gsap.to(item.querySelector('.accordion__body'), {
          clearProps: 'all',
          duration: 0.543,
          ease: 'power3.inOut',
          height: action === 'open' ? 'auto' : 0,
          opacity: action === 'open' ? 1 : 0,
          onComplete: ScrollTrigger.refresh,
          onStart: () => {
            if (action === 'open') {
              item.firstElementChild.ariaExpanded = 'true'
              item.classList.add('accordion__item--active')
            } else {
              item.firstElementChild.ariaExpanded = 'false'
              item.classList.remove('accordion__item--active')
            }
          },
        })
      },

      toggleItem(item): void {
        const isActive = item.classList.contains('accordion__item--active')

        this.runAnimation(isActive ? 'close' : 'open', item)
      },
    }

    method.init()
  },
}

export default accordion
